import styled from "styled-components"

interface ModalHeader {
  bgImagen?: string
}

export const ModalHeader = styled.div`
  background-image: url(${(p: ModalHeader) => (p.bgImagen ? p.bgImagen : "")});
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: cover;
  width: 100%;
  height: 5rem;
  display: flex;
  align-items: center;
  font-family: MontserratRegular;
`

interface ModalTitle {
  textColor?: string
}

export const ModalTitle = styled.h1`
  font-size: clamp(2.2rem, 2vw, 3rem);
  color: ${(p: ModalTitle) => p.textColor ? p.textColor : "var(--color-text)"};
  margin-left: 10px;
`

export const ModalBody = styled.div`
  width: 100%;
  padding: 1.5rem;
  overflow-y: auto;
  max-height: 40rem;
`

export const ModalBodyContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: fit-content;
`

export const ModalFooter = styled.div`
  width: 100%;
  padding: 1rem 2rem 1rem 2rem;
  display: flex;
  flex-direction: row;
  justify-content: end;
`
